module.exports = __webpack_public_path__ + "static/media/mobile_informativo_03.a72aee66.png";